<template>
	<div class="photo-manager">
		<div class="photo-manager__photo" v-for="(photo, photoIndex) in photos" :key="photoIndex" v-show="photoSlotIsVisible(photoIndex)">
			<div class="photo-manager__number">{{ photoIndex + 1 }}</div>
			<div class="photo-manager__photo-wrapper">
				<div class="preview" v-if="photoHasSource(photo)">
					<label :for="'photo-'+typeId+'-'+photoIndex">
						<img :src="getPhotoSource(photo)" />
					</label>
					<div v-if="photoHasSource(photo)">
						<i class="fa fa-trash remove-cta" @click="removePhoto(photo)"></i>
					</div>
				</div>
				<div v-else>
				<file-pond
					:name="`photos[${typeId}][]`"
					:ref="`pond${typeId}`"
					label-idle='<i class="fa fa-upload"></i> Click here to upload image'
					:allow-multiple="false"
					accepted-file-types="image/*,capture=camera"
					:store-as-file="true"
					:max-files="1"
					:image-resize-target-width="1600"
					:image-resize-upscale="false"
					:required="hasNoPhotos"
					@updatefiles="fileUpdated($event, photoIndex)"
				/>

				</div>


				<span class="help-block" v-if="photo.error">
					<strong>{{ photo.error }}</strong>
				</span>
			</div>




		</div>

		<template v-for="removedPhoto in removedPhotos">

			<input type="hidden" name="remove[]" :value="removedPhoto" :key="removedPhoto">

		</template>

    <template v-for="(photo, photoIndex) in photos">
			<template v-if="photo.id && photo.isDefault">
				<input type="hidden" name="copy_photos[]" :value="photo.id" :key="'copy-' + photo.id">
			</template>
		</template>
	</div>
</template>

<script>
import axios from 'axios';
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImageResize from 'filepond-plugin-image-resize'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImageResize, FilePondPluginImagePreview);

export default {
  props: ['typeId', 'maxUploads', 'consultationId', 'defaultPhotos'],
  data: function() {
    return {
      photos: [],
      removedPhotos: [],
      visibleSlots: 1,
      photosWithSource: [],
      sizeLimit: 105906176, // 101MB
      filepondImages: [],
    };
  },
  mounted() {
    this.buildPhotos();
    this.loadDefaultPhotos();
    if (this.consultationId) {
      this.retrievePhotos();
    }
  },
  computed: {
    hasNoPhotos() {
      return this.photosWithSource.length === 0 && this.filepondImages.length === 0
    }
  },
  methods: {
    buildPhotos: function() {
      let photos = [];
      for (let i = photos.length; i < this.maxUploads; i++) {
        photos.push({ source: '', error: '', file: '' });
      }
      this.photos = photos;
    },
    loadDefaultPhotos: function() {
      if (this.defaultPhotos && Array.isArray(this.defaultPhotos)) {
        // Filter default photos for this specific type
        const typeDefaultPhotos = this.defaultPhotos.filter(photo => 
          photo.type == this.typeId
        );
        
        // Load default photos into the photos array
        for (let i = 0; i < typeDefaultPhotos.length && i < this.maxUploads; i++) {
          this.photos[i] = {
            id: typeDefaultPhotos[i].id,
            file: typeDefaultPhotos[i].file,
            source: typeDefaultPhotos[i].file,
            isDefault: true,
            error: ''
          };
        }
        
        // Update visible slots and photos with source
        if (typeDefaultPhotos.length > 0) {
          this.visibleSlots = Math.min(typeDefaultPhotos.length + 1, this.maxUploads);
          this.updatePhotosWithSource();
        }
      }
    },
    retrievePhotos: function() {
      axios.get(`/api/v1/consultation/${this.consultationId}/photos/${this.typeId}`).then((response) => {
        if (response.data) {
          for (let i = 0; i < response.data.length; i++) {
            this.photos[i] = response.data[i];
            this.visibleSlots++;
            this.updatePhotosWithSource();
          }
        }
      });
    },
    photoHasSource: function(photo) {
      return photo.source || photo.file;
    },
    getPhotoSource: function(photo) {
      return photo.source ? photo.source : photo.file;
    },
    updatePhotosWithSource: function() {
      this.photosWithSource = this.photos.filter((photo) => this.photoHasSource(photo));
    },
    photoSlotIsVisible: function(index) {
      return true
    },
    removePhoto: function(photo) {
      if (photo.inputField) {
        var input = document.getElementById(photo.inputField.id);
        input.value = '';
      }
      if (photo.id) {
        this.removedPhotos.push(photo.id);
      }
      photo.source = photo.file = photo.id = '';
      this.updatePhotosWithSource();
    },
    fileUpdated(e, index) {
      if (e.length) {
        if (this.filepondImages.indexOf(index) === -1) {
          this.filepondImages.push(index)
        }
      } else {
        this.filepondImages.splice(this.filepondImages.indexOf(index), 1)
      }
    },
  },
  components: {
    FilePond
  }
}
</script>

<style scoped>
	.filepond--item::before {
		display: none !important;
	}
</style>



// WEBPACK FOOTER //
// resources/assets/js/PhotoManager.vue